import * as React from 'react'
import InputField from '../../common/components/input-field'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import QuoteNumber from '../../common/components/quote-number'
import QueryString from 'query-string'
import checkOptions from '../../common/options/check-options'
import yesNoOptions from '../../common/options/yes-no-options'
import { get } from 'lodash'
import { toCurrency, optionsToInts } from '../../common/util'
import { getQueryString } from '../../common/util'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withProductData } from '../../common/modules/product-data'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withState } from '../../common/modules/state'
import { withRouteBlocker } from '../../common/modules/route-blocker'


export const formConfig = state => {
    const fields = state.fields;
    const catastropheCoverAmount = fields.buildingSumInsured * (fields.catastrophePercent/100);
    const selectedState = get(fields, 'ownersCorporationAddress.state')
    const productData = state.productData;
    
    return {
        rules: {
            lossOfRentPercent:[
                Validation.enforce.required("Please select a value"),
            ],
            liabilitySumInsured :[
                Validation.enforce.required("Please select a value"),
            ],
            voluntaryWorkersRequired: state !== "NSW" ? [] : [
                Validation.enforce.required("Required"),
            ],
            voluntaryWorkersDeath:[
                Validation.enforce.required("Please select a value"),
            ],
            workersCompensationRequired:[
                Validation.enforce.required("Required"),
            ],
            estimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a dollar value"),
                Validation.enforce.predicate(value => fields.ownersCorporationAddress.state == "NSW" ? value > 7500 : true, "Workers Compensation Cover only available where wages exceed $7,500")
            ],
            employeesEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourOnlyEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourMaterialsEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourPlantEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            labourPlantMaterialsEstimatedWages:[
                Validation.enforce.required("Please enter an amount"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            fidelityRequired: state !== "SA" ? [] : [
                Validation.enforce.required("Required"),
            ],
            fidelitySumInsured:[
                Validation.enforce.required("Please select a value"),
            ],
            officeBearersRequired:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
            officeBearersSumInsured:[
                Validation.enforce.required("Please select a value"),
            ],
            machineryBreakdownRequired:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
            machineryBreakdownSumInsured:[
                Validation.enforce.required("Please select a value"),
            ],
            carStackerTurnTable:[
                Validation.enforce.required("Please answer the question"),
            ],
            airConditioningLocation:[
                Validation.enforce.required("Please select a value"),
            ],
            electronicMotors5KW:[
                Validation.enforce.required("Please answer the question"),
            ],
            chillersOrCoolingTowers:[
                Validation.enforce.required("Please answer the question"),
            ],
            catastropheRequired:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
            catastrophePercent:[
                Validation.enforce.required("Please select a value"),
                Validation.enforce.number("Must be a whole number"),
                Validation.enforce.rangeInclusive(15, 30, "Must be between 15% and 30%"),
            ],
            governmentAuditIncluded:[
                Validation.enforce.required("Please select a value")
            ],
            lotOwnersIncluded:[
                Validation.enforce.required("Please select a value")
            ]
        },
        predicates:{
            workersCompensationRequired: selectedState === "ACT" || selectedState === "TAS" || selectedState === "WA",
            estimatedWages: selectedState !== "WA" && fields.workersCompensationRequired === true,
            employeesEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourOnlyEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourMaterialsEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourPlantEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            labourPlantMaterialsEstimatedWages: selectedState === "WA" && fields.workersCompensationRequired === true,
            
            fidelityRequired: selectedState !== "SA",
            fidelitySumInsured: fields.fidelityRequired || selectedState === "SA",
            
            officeBearersSumInsured: fields.officeBearersRequired === true,

            voluntaryWorkersRequired: selectedState !== "NSW",
            voluntaryWorkersDeath: fields.voluntaryWorkersRequired || selectedState === "NSW",
            voluntaryWorkersDisablement: fields.voluntaryWorkersRequired || selectedState === "NSW",

            machineryBreakdownSumInsured: fields.machineryBreakdownRequired === true,
            carStackerTurnTable: fields.machineryBreakdownRequired === true,
            airConditioningLocation: fields.machineryBreakdownRequired === true,
            electronicMotors5KW: fields.machineryBreakdownRequired === true,
            chillersOrCoolingTowers: fields.machineryBreakdownRequired === true,

            catastrophePercent: fields.catastropheRequired === true,
            catastropheCoverAmount: fields.catastropheRequired === true,
            storageAndEvacuationAmount: fields.catastropheRequired === true,
            temporaryAccommodationAmount: fields.catastropheRequired === true,
            temporaryAccommodationEscalationOfCostsAmount: fields.catastropheRequired === true,

            governmentAuditAmount: fields.governmentAuditIncluded === true,
            appealExpensesAmount: fields.governmentAuditIncluded === true,
            legalDefenceAmount: fields.governmentAuditIncluded === true,
            lotOwnersSumInsured: fields.lotOwnersIncluded === true,
        },
        options:{
            officeBearersRequired: yesNoOptions,
            officeBearersSumInsured: productData.productSumsInsured.OfficeBearersLiability,
            lossOfRentPercent: optionsToInts( productData.productOptions.LOSS_OF_RENT_PERCENT ),
            workersCompensationRequired: yesNoOptions,
            machineryBreakdownRequired: yesNoOptions,
            machineryBreakdownSumInsured: productData.productSumsInsured.MachineryBreakdown,
            carStackerTurnTable: yesNoOptions,
            airConditioningLocation: productData.productOptions.MB_AIRCON,
            electronicMotors5KW: yesNoOptions,
            chillersOrCoolingTowers: yesNoOptions,
            catastropheRequired: yesNoOptions,
            governmentAuditIncluded: yesNoOptions,
            lotOwnersIncluded: yesNoOptions,
            fidelityRequired: yesNoOptions,
            fidelitySumInsured: productData.productSumsInsured.Fidelity,
            catastrophePercent: optionsToInts( productData.productOptions.CATASTROPHE_PERCENT ),
            voluntaryWorkersRequired: yesNoOptions,
            voluntaryWorkersDeath: productData.productSumsInsured.VoluntaryWorkers
        },
        inferred:{
            lossOfRentSum: Math.round((fields.lossOfRentPercent / 100) * fields.buildingSumInsured),
            voluntaryWorkersDisablement: toCurrency(fields.voluntaryWorkersDeath * 0.01),
            catastropheCoverAmount: toCurrency(catastropheCoverAmount),
            storageAndEvacuationAmount: toCurrency(catastropheCoverAmount * 0.05),
            temporaryAccommodationAmount: toCurrency(catastropheCoverAmount * 0.15),
            temporaryAccommodationEscalationOfCostsAmount: toCurrency(catastropheCoverAmount * 0.05),
            governmentAuditAmount: toCurrency(25000),
            appealExpensesAmount: toCurrency(100000),
            legalDefenceAmount: toCurrency(50000),
            lotOwnersSumInsured: toCurrency(250000)
        },
        transformOut: data => {
            return {
                ...data,
                voluntaryWorkersRequired: selectedState === "NSW" ? true : fields.voluntaryWorkersRequired,
                fidelityRequired: selectedState === "SA" ? true : fields.fidelityRequired,
            }
        }
    }

}


@withSubmission
@withNavigation
@withProductData
@withValidation
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {

    
    render() {
        const formData = this.props.form.getData();
        const predicates = formData.predicates;
        const inferred = formData.inferred;

        return (   
            <div className="row">
                <StepTitle>Your Extra Covers</StepTitle>
                <QuoteNumber />


                <SubHeader>Insured Property</SubHeader>
                <InputField     field="lossOfRentPercent"                                                  inline                label="What percentage of your Building sum insured would you like to insure for Loss of rent?"  help="This is the rent you would have lost if Your Lot/Unit or Common Area is made unfit to be occupied for its intended purpose. Read the PDS for more information."/>
                <InputField     field="lossOfRentSum"                                  type="Currency"     inline                label="Loss of Rent/Temporary Accommodation (total payable)"  help="We will, up to the Sum Insured stated on the Schedule, indemnify You in respect of: fraudulent misappropriation of Your funds committed during the Period of Insurance."/>

                <SubHeader>Voluntary Workers</SubHeader>
                <InputField     field="voluntaryWorkersRequired"                       type="Boolean"      inline                 label="Do you require Voluntary Workers cover?"/>
                <InputField     field="voluntaryWorkersDeath"                          type="Currency"     inline                 label="Death"/>
                <InputField     field="voluntaryWorkersDisablement"                    type="Currency"     inline                 label="Total Disablement (Per Week)"/>

                <SubHeader show={ predicates.workersCompensationRequired }>Workers Compensation</SubHeader>
                <InputField    field="workersCompensationRequired"                     type="Boolean"                            label="Do you require Workers Compensation cover"    />
                <InputField    field="estimatedWages"                                  type="Currency"     inline                label="Estimated wages paid"                         />
                <InputField    field="employeesEstimatedWages"                         type="Currency"     inline                label="Employees estimated wages"                    />
                <InputField    field="labourOnlyEstimatedWages"                        type="Currency"     inline                label="Labour only estimated wages"                  />
                <InputField    field="labourMaterialsEstimatedWages"                   type="Currency"     inline                label="Labour and Materials estimated wages"         />
                <InputField    field="labourPlantEstimatedWages"                       type="Currency"     inline                label="Labour and plant estimated wages"             />
                <InputField    field="labourPlantMaterialsEstimatedWages"              type="Currency"     inline                label="Labour, plant and materials estimated wages"  />

                <SubHeader>Fidelity Guarantee</SubHeader>
                <InputField    field="fidelityRequired"                                type="Boolean"      inline                label="Do you require Fidelity Guarantee cover?"      help="We will, up to the Sum Insured stated on the Schedule, indemnify You in respect of: fraudulent misappropriation of Your funds committed during the Period of Insurance."/>
                <InputField    field="fidelitySumInsured"                              type="String"       inline                label="Fidelity Guarantee Sum Insured"      />

                <SubHeader>Office Bearers</SubHeader>           
                <InputField    field="officeBearersRequired"                            type="Boolean"                            label="Do you require Office Bearers cover?" />
                <InputField    field="officeBearersSumInsured"                          type="String"      inline                 label="Office Bearers Sum Insured"           />

                
                <SubHeader>Machinery Breakdown Cover</SubHeader>
                <InputField    field="machineryBreakdownRequired"                      type="Boolean"      inline                label="Do you require Machinery Breakdown cover?"                     />
                <InputField    field="machineryBreakdownSumInsured"                    type="Currency"     inline                label="Machinery Breakdown sum insured"                               />
                <InputField    field="carStackerTurnTable"                             type="Boolean"      inline                label="Is there a car stacker or turntable?"                          />
                <InputField    field="airConditioningLocation"                         type="String"       inline                label="Is air conditioning located centrally or in individual lots?"  />
                <InputField    field="electronicMotors5KW"                             type="Boolean"      inline                label="Are there any motors in excess of 5Kw?"                        />
                <InputField    field="chillersOrCoolingTowers"                         type="Boolean"      inline                label="Are there any chilling or cooling towers?"                     />
                
                <SubHeader>Catastrophe Insurance</SubHeader>
                <InputField    field="catastropheRequired"                             type="Boolean"                            label="Do you require Catastrophe Insurance?"                                            />
                <InputField    field="catastrophePercent"                              type="Percent"      inline                label="Percentage of the building sum insured that is insured for catastrophe cover?"    />
                <InputField    field="catastropheCoverAmount"                          type="Currency"     inline                label="Sum insured for catastrophe cover"                                                />
                <InputField    field="storageAndEvacuationAmount"                      type="Currency"     inline                label="Sum insured for storage and evacuation"                                           />
                <InputField    field="temporaryAccommodationAmount"                    type="Currency"     inline                label="Sum insured for loss of rent/temporary accommodation"                             />
                <InputField    field="temporaryAccommodationEscalationOfCostsAmount"   type="Currency"     inline                label="Sum insured for temporary accommodation escalation of cost"                       />

                <SubHeader>Government Audit Costs and Legal Expenses</SubHeader>
                <InputField    field="governmentAuditIncluded"                                                                   label="Do you require Government Audit Costs and Legal Expenses cover?"                  />
                <InputField    field="governmentAuditAmount"                           type="Currency"   inline                  label="Government Audit Costs"                                                           />
                <InputField    field="appealExpensesAmount"                            type="Currency"   inline                  label="Appeal expenses - common property health & safety breaches"                       />
                <InputField    field="legalDefenceAmount"                              type="Currency"   inline                  label="Legal Defence Expenses"                                                           />


                <SubHeader>Lot Owner's Fixtures and Improvements</SubHeader>
                <InputField    field="lotOwnersIncluded"                                                                         label="Do you require Lot Owner's Fixtures and Improvements cover?"   inline={ true }    />
                <InputField    field="lotOwnersSumInsured"                             type="Currency"                           label="Sum Insured (per lot)"                                         inline={ true }    />
                

                <Button.Container>
                    <Button.Back route="/step-4" /> <Button.Continue onClick={ this.validate.bind(this) } /> <Button.Save onClick={ this.save.bind(this) }/> 
                </Button.Container>
            </div>
        )
    }


    save(){
        console.log("Save")
        this.props.actions.submission.save("/step-5", [
            require('./step-1').formConfig,
            require('./step-2').formConfig,
            require('./step-3').formConfig,
            require('./step-4').formConfig,
            require('./step-5').formConfig
        ])
    }


    validate(){
        console.log("Validate")
        this.props.actions.validation.validate( this.proceed.bind(this) );
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-6")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-5.tsx